import { Chip } from "@mui/material";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { StateWasteStreamRegistrationStatus } from "generated-graphql/graphql";

// IN_PROGRESS collides with the "IN" (Indiana) state-abbreviation heuristic in
// the default enum pretty-printer, so this enum opts out of it (see
// FilterKey.ignoreStateAbbreviations for the write-up).
export function statusLabel(status: StateWasteStreamRegistrationStatus): string {
  return prettyPrintEnumValue(status, undefined, true);
}

const STATUS_COLOR: Record<StateWasteStreamRegistrationStatus, "success" | "info" | "default"> = {
  [StateWasteStreamRegistrationStatus.Registered]: "success",
  [StateWasteStreamRegistrationStatus.InProgress]: "info",
  [StateWasteStreamRegistrationStatus.Closed]: "default",
};

/**
 * The status pill shown in the grid, the edit drawer, and the create dialog's
 * status select — one source of truth for the label + color of a registration
 * status so those surfaces can't drift.
 */
export function StatusBadge({ status }: { status: StateWasteStreamRegistrationStatus }) {
  return <Chip label={statusLabel(status)} color={STATUS_COLOR[status]} size="small" />;
}
